import React, { Component } from 'react'
import { Container, Table, Button, Spinner } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav, Loading } from '../../helpers';

import axios from 'axios'
class RequestTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listInComplete: false,
      inCompleteLoading: true,
      completedLoading: false,
      CompanyList: [],
      networkStatus: null,
      modalRemoveRequest: false,
      removeID: 999999,

    }
    this.handleTableClick = this.handleTableClick.bind(this)
    this.handleModalRemoveRequest = this.handleModalRemoveRequest.bind(this)
    this.handleRemoveRequest = this.handleRemoveRequest.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.handleEditTableClick = this.handleEditTableClick.bind(this)
  }
  componentDidMount() {
    // console.log(this.props.location?.state?.timeValue)

    let date = new Date()
    let days = date.getDate()
    if (parseInt(days) < 10) {
      days = `0${days}`
    }
    let month = parseInt(date.getMonth()) + 1
    if (parseInt(month) < 10) {
      month = `0${month}`
    }
    let year = date.getFullYear()
    let saveDate = `${year}-${month}-${days}`
    let viewAllSurveyRequestSheetByDate = fetch(`https://backend1.riceinspections.com/testAA?timeValue=${this.props.location?.state?.timeValue || saveDate}`).then((res) => {
    //fetch(`https://backend1.riceinspections.com/testAA?timeValue=${this.props.location?.state?.timeValue || saveDate}`).then((res) => {
    //fetch(`https://backend1.riceinspections.com/testAA?timeValue=${this.props.location?.state?.timeValue || saveDate}`).then((res) => {
      console.log(viewAllSurveyRequestSheetByDate)
      return res.json()
    })
    // let viewAllCompany = fetch(`  `).then((res) => {
    //   return res.json()
    // })
    //fetch(`https://backend1.riceinspections.com/testpageinformation?page=${window.location.href}&version=test`)

    Promise.all([viewAllSurveyRequestSheetByDate])
      .then((res) => {
        viewAllSurveyRequestSheetByDate = res[0]
       // viewAllCompany = res[1]
        if (viewAllSurveyRequestSheetByDate) {
          Object.values(viewAllSurveyRequestSheetByDate).map((data) => {
            // Object.values(viewAllCompany).map((companyData) => {
            //   if (data.companyID == companyData.companyID) {
            //     data['companyEN'] = companyData.companyNameEN
            //   }
            // })
          })
          this.setState({
            ...this.state,
            viewAllSurveyRequestSheetByDate: viewAllSurveyRequestSheetByDate,
            inCompleteLoading: false
          })
        } else {
          this.setState({
            ...this.state,
            viewAllSurveyRequestSheetByDate: {},
            inCompleteLoading: false
          })
        }
      }).catch((err) => {
        this.setState({
          ...this.state,
          networkStatus: 'การเชื่อมต่ออินเทอร์เน็ตมีปัญหา'
        })
        // setTimeout(() => {
        //   window.location.reload()
        // }, 5000)
      })
  }
  handleTableClick = (e) => {
    // console.log(e.target.parentElement.id)
    let date = new Date()
    let days = date.getDate()
    if (parseInt(days) < 10) {
      days = `0${days}`
    }
    let month = parseInt(date.getMonth()) + 1
    if (parseInt(month) < 10) {
      month = `0${month}`
    }
    let year = date.getFullYear()
    let saveDate = `${year}-${month}-${days}`

    this.props.history.push({
      pathname: '/request',
      // state: this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id],
      date: this.props.location?.state?.timeValue || saveDate,
      state: {
        timeValue: this.props.location?.state?.timeValue || saveDate,
        timeShow: this.props.location?.state?.timeShow || date
      }
    })
  }
  handleModalRemoveRequest = (requestID) => {
    this.setState({
      ...this.state,
      modalRemoveRequest: true,
      removeID: requestID,
    })
  }
  closeModal() {
    this.setState({
      ...this.state,
      modalRemoveRequest: false,
    })
  }

  renderAlertCompany(requestID, modalStatus) {
    if (requestID != 999999 && modalStatus == true) {
      return <Loading mode='warningText' title='is' handleRemoveRequestID={() => { this.handleRemoveRequest(requestID) }} closeModal={this.closeModal} requestID={requestID} />
    } else {
      return <div></div>
    }
  }

  onChageDate = (date) => {
    date = new Date(date)
    let yearNum = date.getFullYear()
    let monthNum = parseInt(date.getMonth()) + 1
    let dayNum = date.getDate()
    if (parseInt(monthNum) < 10) {
      monthNum = `0${monthNum}`
    }
    if (parseInt(dayNum) < 10) {
      dayNum = `0${dayNum}`
    }
    let saveDate = `${yearNum}-${monthNum}-${dayNum}`
    this.setState({
      ...this.state,
      shippingDate: saveDate,
      showShippingDate: date,
    })
  }
  renderDate(dateObj) {
    let dateParser = new Date(dateObj)
    let day = dateParser.getDate()
    let month = dateParser.getMonth() + 1
    let years = dateParser.getFullYear() + 543
    return `${day}/${month}/${years}`
  }
  handleRemoveRequest(requestID) {
    let deleteSurveyRequest = axios.post(
      'https://backend1.riceinspections.com/testJ',
      {
        data: { 'requestID': requestID },
      }
    )

    deleteSurveyRequest.then((res) => {

      if (res.data.data) {
        let date = new Date()
        let days = date.getDate()
        if (parseInt(days) < 10) {
          days = `0${days}`
        }
        let month = parseInt(date.getMonth()) + 1
        if (parseInt(month) < 10) {
          month = `0${month}`
        }
        let year = date.getFullYear()
        let saveDate = `${year}-${month}-${days}`



        let viewAllSurveyRequestSheetByDate = fetch(`https://backend1.riceinspections.com/testAA?timeValue=${this.props.location?.state?.timeValue || saveDate}`).then((res) => {
          return res.json()
        })
        let viewAllCompany = fetch(`https://backend1.riceinspections.com/testAB`).then((res) => {
          return res.json()
        })
        // fetch(`https://backend1.riceinspections.com/testpageinformation?page=${window.location.href}&version=test`)

        Promise.all([viewAllSurveyRequestSheetByDate, viewAllCompany])
          .then((res) => {
            viewAllSurveyRequestSheetByDate = res[0]
            viewAllCompany = res[1]
            if (viewAllSurveyRequestSheetByDate) {
              Object.values(viewAllSurveyRequestSheetByDate).map((data) => {
                Object.values(viewAllCompany).map((companyData) => {
                  if (data.companyID == companyData.companyID) {
                    data['companyEN'] = companyData.companyNameEN
                  }
                })
              })
              this.setState({
                ...this.state,
                viewAllSurveyRequestSheetByDate: viewAllSurveyRequestSheetByDate,
                inCompleteLoading: false,
                modalRemoveRequest : false
              })
            } else {
              this.setState({
                ...this.state,
                viewAllSurveyRequestSheetByDate: {},
                inCompleteLoading: false, 
                modalRemoveRequest : false
              })
            }
          }).catch((err) => {
            this.setState({
              ...this.state,
              networkStatus: 'การเชื่อมต่ออินเทอร์เน็ตมีปัญหา'
            })
            setTimeout(() => {
              window.location.reload()
            }, 5000)
          })

      } else {
        alert('ไม่สามารถลบได้เนื่องจากมีใบ Checkweight เรียบร้อยแล้ว')
      }

    })

  }
  handleEditTableClick = (e) => {
    this.props.history.push({
      pathname: '/RequestEdit',
      state: {
        ...this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id],
        timeShow: this.props.location.state.timeShow || new Date(),
        timeValue: this.props.location.state.timeValue || new Date()
      },
      date: this.props.location.state.timeValue || new Date(),
    })
  }

  render() {
    if (!this.state.inCompleteLoading) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <br></br>
          <div style={{ display: 'flex', alignItem: 'center',backgroundColor:'gray' }}>
            <p style={{ margin: '0 auto', fontSize: '18px',color:'white' }}><b>ย้ายเว็บไซต์ค้นหาใบ อ.๒ ใหม่ ไปอยู่ที่เว็บไซต์ <a style={{color : 'white'}} href='http://search.riceinspectionerp.com'>search.riceinspectionerp.com</a> </b></p>
          </div>

          <div style={{ display: 'flex', alignItem: 'center' }}>
            <p style={{ margin: '0 auto', fontSize: '32px' }}><b>แจ้งขอตรวจสอบข้าว ประจำวันที่ {this.renderDate(this.props.location?.state?.timeValue || new Date())}</b></p>
          </div>

          <Button variant="success" onClick={() => { this.handleTableClick(this.state.arr) }}> เพิ่มแจ้งขอตรวจสอบ </Button>

          <br />          <br />
          <Table bordered hover>
            <thead>
              <tr>
                <th>ลำดับ</th>
                <th style={{ textAlign: 'left' }}>บริษัทผู้ส่งออก</th>
                <th style={{ textAlign: 'left' }}>สถานที่บรรทุก</th>
                <th style={{ textAlign: 'left' }}>อำเภอบรรทุก</th>
                <th style={{ textAlign: 'left' }}>จังหัวดบรรทุก</th>
                <th style={{ textAlign: 'left' }}>ยกเลิก</th>

              </tr>
            </thead>
            <tbody>
              {(() => {
                if (this.state.viewAllSurveyRequestSheetByDate) {
                  return Object.keys(this.state.viewAllSurveyRequestSheetByDate).map((res, idx) => {
                    let c = this.state.viewAllSurveyRequestSheetByDate[res]
                    if (res === 'requestCount') {
                      return null;
                    }
                    return (
                      <tr id={res} >
                        <td>{idx + 1}</td>
                        <td style={{ textAlign: 'left' }} onClick={this.handleEditTableClick}>{c.companyID}</td>
                        <td style={{ textAlign: 'left' }} onClick={this.handleEditTableClick}>{c.surveyLocateName}</td>
                        <td style={{ textAlign: 'left' }} onClick={this.handleEditTableClick}>{c.surveyDistrict}</td>
                        <td style={{ textAlign: 'left' }} onClick={this.handleEditTableClick}>{c.surveyProvince}</td>
                        <td><Button onClick={() => { this.handleModalRemoveRequest(c.requestID) }}> ยกเลิก </Button></td>

                      </tr>
                    )
                  })
                }
              })()
              }
            </tbody>
          </Table>
          {this.renderAlertCompany(this.state.removeID, this.state.modalRemoveRequest)}

        </Container>
      )
    }
    else {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading title={this.state.networkStatus} />
      </Container>)
    }
  }
}


export default withRouter(RequestTable);
